import React from "react";
import { Navigate } from "react-router-dom";

function AdministrationProtectedRoute({ children }) {
  const token = localStorage.getItem("administration-token");

  if (!token) {
    return <Navigate to="/administration/login" replace />;
  }

  return children;
}

export default AdministrationProtectedRoute;
